import { LanguageCertificate } from "@/lib";
import React, { memo } from "react";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { format } from "date-fns";
import { EmptyPlaceholderField } from "./partials/EmptyPlaceholderField";
import { Input } from "../ui/input";

export const LanguageCertificateDetail = memo(({ data, setDegreeInformation }: { data: LanguageCertificate | null; setDegreeInformation: React.Dispatch<React.SetStateAction<LanguageCertificate | null>> }) => {
	if (data === null) {
		return <></>;
	}
	return (
		<div>
			<Dialog
				open={data !== null}
				onOpenChange={() => {
					setDegreeInformation(null);
				}}
			>
				<DialogContent className='max-w-6xl'>
					<DialogHeader>
						<DialogTitle>Thông Tin Chi Tiết Chứng Chỉ Ngoại Ngữ </DialogTitle>
					</DialogHeader>
					<div className='grid grid-cols-1 gap-3 h-[50dvh] overflow-y-scroll px-1 pb-3'>
						<div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3'>
							<div className='col-span-1 text-red-600 font-bold'>Thông tin cá nhân</div>
							<div>
								<Label className='mb-1'>Số báo danh</Label>
								<EmptyPlaceholderField data={data.studentId} />
							</div>
							<div>
								<Label className='mb-1'>Họ và tên</Label>
								<div style={{ 'textTransform': 'capitalize' }}>
									<EmptyPlaceholderField data={data.studentName} />
								</div>
							</div>
							<div>
								<Label className='mb-1'>Ngày sinh</Label>
								<EmptyPlaceholderField data={data.dateOfBirth ? format(data.dateOfBirth as unknown as Date, "dd/MM/yyyy") : ""} />
							</div>
							<div>
								<Label className='mb-1'>Nơi sinh</Label>
								<EmptyPlaceholderField data={data.placeOfBirth} />
							</div>
							<div>
								<Label className='mb-1'>Giới tính</Label>
								<EmptyPlaceholderField data={data.gender} />
							</div>
							<div>
								<Label className='mb-1'>CCCD</Label>
								<EmptyPlaceholderField data={data.cccd} />
							</div>
							<div>
								<Label className='mb-1'>Mã dân tộc</Label>
								<EmptyPlaceholderField data={data.ethnicCode} />
							</div>
							<div>
								<Label className='mb-1'>Dân tộc</Label>
								<EmptyPlaceholderField data={data.ethnicity} />
							</div>
							<div>
								<Label className='mb-1'>Mã quốc tịch</Label>
								<EmptyPlaceholderField data={data.nationalityCode} />
							</div>
							<div>
								<Label className='mb-1'>Quốc tịch</Label>
								<EmptyPlaceholderField data={data.nationality} />
							</div>
							<div className='md:col-span-1 lg:col-span-1'>
								<Label className='mb-1'>Ghi chú</Label>
								<EmptyPlaceholderField data={data.notes} />
							</div>
						</div>
						<div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3'>
							<div className='col-span-1 text-red-600 font-bold'>Thông tin chứng chỉ</div>
							<div>
								<Label className='mb-1'>Số hiệu chứng chỉ</Label>
								<EmptyPlaceholderField data={data.certificateNumber} />
							</div>
							{/* <div>
								<Label className='mb-1'>Mã ngôn ngữ</Label>
								<Input value={data.languageCode || ""} readOnly tabIndex={-1} />
							</div> */}
							<div>
								<Label className='mb-1'>Trình độ</Label>
								<EmptyPlaceholderField data={data.level} />
							</div>
							{/* <div>
								<Label className='mb-1'>Mã loại chứng chỉ</Label>
								<Input value={data.certificateTypeId || ""} readOnly tabIndex={-1} />
							</div> */}
							{/* <div>
								<Label className='mb-1'>Ngày thi</Label>
								<Input value={data.examDate ? format(data.examDate as unknown as Date, "dd/MM/yyyy") : ""} readOnly tabIndex={-1} />
							</div> */}

							<div>
								<Label className='mb-1'>Địa điểm thi</Label>
								<EmptyPlaceholderField data={data.examCenter} />
							</div>
							{/* <div>
								<Label className='mb-1'>Ngày cấp</Label>
								<EmptyPlaceholderField data={data.issueDate} />
							</div> */}
							<div>
								<Label className='mb-1'>Người ký</Label>
								<EmptyPlaceholderField data={data.signedBy} />
							</div>

							<div>
								<Label className='mb-1'>Chức danh người ký</Label>
								<EmptyPlaceholderField data={data.signerTitle} />
							</div>

							<div>
								<Label className='mb-1'>Ngày ký</Label>
								<EmptyPlaceholderField data={data.signDate ? format(data.signDate as unknown as Date, "dd/MM/yyyy") : ""} />
							</div>

							{/* <div>
								<Label className='mb-1'>Ngày hết hạn</Label>
								<Input value={data.expiryDate ? format(data.expiryDate as unknown as Date, "dd/MM/yyyy") : ""} readOnly tabIndex={-1} />
							</div> */}
							<div className='col-span-1 text-red-600 font-bold'>Trạng thái đồng bộ</div>
							<div>
								<Label className='mb-1'>Trạng thái</Label>
								<EmptyPlaceholderField data={data.status} />
							</div>
						</div>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
});
